import axios from "axios";

export const api = axios.create({
  baseURL: "http://3.80.69.198"
})